// EmailsServiceProvider.tsx
import { create } from '../services/CRUDServiceProvider';
import { Email } from '../types/email';

let app_email_url_path = 'contact';

export const sendEmailContact = async (email: Email): Promise<Email> => {
    try {
        const response = await await create<any>(app_email_url_path, email, 'application/json');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export function validateEmail(email: Email) {
    let issues: any = [];

    if (!email.message) {
        issues = [...issues, { message: 'Message is required', path: ['message'] }];
    }
    if (!email.email) {
        issues = [...issues, { message: 'Email required', path: ['email'] }];
    }

    console.log(email);
    console.log(issues);

    return { issues };
};

